<template>
    <div class="view view__session_show">
        <template v-if="allow">
            <session-show/>
        </template>
    </div>
</template>

<script>
import SessionShow from '@/components/ebs/sessions/show/SessionShow'
import { User } from '@/User'

export default {
  components: { SessionShow },
  name: 'view-session-show',
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData)
    }
  },
  computed: {
    routeSessionId () {
      return this.$route.params.sessionId
    },
    routeSessionEventId () {
      return this.$route.params.eventId
    },
    //
    sessionId () {
      return this.$store.getters.getSessionId
    },
    sessionEventId () {
      return this.$store.getters.getEventId
    },
    sessionStatus () {
      return this.$store.getters.getSessionDefaultStatus
    },
    sessionInProgress () {
      return this.$store.getters.getSessionSessionInfoInProgress
    },
    sessionDatetimeEnd: function () {
      return this.$store.getters.getSessionDatetimeEnd
    },
    //
    sessionCustomCancellationSuccess () {
      return this.$store.getters.getSessionCustomCancellationSuccess
    },
    //
    allow: function () {
      return !(this.sessionStatus === 'draft' && this.user.isOnlyLearner())
    },
    isSessionEndedJustNow: function () {
      const sessionTime = new Date(this.sessionDatetimeEnd)
      const localTime = new Date()
      return (sessionTime < localTime) && this.sessionInProgress
    }
  },
  watch: {
    routeSessionId () {
      this.initializeGetSession()
    },
    sessionCustomCancellationSuccess (value) {
      if (value) {
        this.initializeGetSession()
        this.setSessionCustomCancellationSuccess(false)
      }
    }
  },
  methods: {
    getSession () {
      const sessionID = this.$route.params.sessionId
      return this.$store.dispatch('getSession', sessionID)
    },
    getSessionEvent () {
      const eventID = this.$route.params.eventId
      return this.$store.dispatch('getEventSummary', eventID)
    },
    getSessionFeedbacks () {
      const sessionID = this.$route.params.sessionId
      return this.$store.dispatch('getSessionFeedbacks', sessionID)
    },
    setSessionCustomCancellationSuccess (value) {
      this.$store.dispatch('setSessionCustomCancellationSuccess', value)
    },
    initializeGetSession () {
      this.$eventBus.$emit('start-loading')

      let requestsArr = []
      let requestsCounter = 0

      requestsArr.push(this.getSession)
      requestsArr.push(this.getSessionEvent)
      requestsArr.push(this.getSessionFeedbacks)

      for (let fn of requestsArr) {
        fn().finally(() => {
          requestsCounter++
          if (Number(requestsCounter) === Number(requestsArr.length)) {
            this.$eventBus.$emit('stop-loading')
          }
        })
      }
    }
  },
  mounted () {
    this.$eventBus.$on('perform-get-session', this.initializeGetSession)
  },
  created () {
    this.initializeGetSession()
  },
  beforeDestroy () {
    this.$eventBus.$off('perform-get-session')
  }
}
</script>
